import React from 'react';

/**
 * Stats section for the new footer design.
 * Displays "Join millions of homeowners..." with 3 hardcoded stats.
 */
export const StatsSection: React.FC = () => {
    const stats = [
        { value: '4M+', label: 'Active Users' },
        { value: '12M+', label: 'Page Views' },
        { value: '400K+', label: 'Subscribers' },
    ];

    return (
        <section className="mb-18 bg-[#212121] px-12 py-16">
            <div className="mx-auto max-w-7xl">
                {/* Heading */}
                <p className="mb-28 text-center text-[2.1rem] font-normal leading-[1.06] tracking-[-1.01px] text-white">
                    Join millions of homeowners creating better spaces with
                    ArchiPro.
                </p>

                {/* Stats grid */}
                <div className="flex flex-col items-center justify-center gap-12 md:flex-row md:gap-24">
                    {stats.map((stat) => (
                        <div
                            key={stat.label}
                            className="flex flex-col items-center gap-6"
                        >
                            <span className="text-5xl font-medium leading-[1.06] -tracking-[0.035em] text-white md:text-[4rem] lg:text-[6rem]">
                                {stat.value}
                            </span>
                            <span className="text-[1.35rem] font-semibold text-white">
                                {stat.label}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
